"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _tljPromotionposition = require("@/api/shoppingGift/tljPromotionposition");
var _marketingFunction = require("@/api/marketingFunction");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Account',
  data: function data() {
    return {
      queryData: {
        pid: '',
        status: null,
        type: 2,
        memberId: '',
        phone: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      titleTxt: '',
      operationType: 'add',
      ruleForm: {
        pid: '',
        type: 2
      },
      rules: {
        pid: [{
          required: true,
          message: '请输入pid',
          trigger: 'blur'
        }]
      },
      getTljPidUseInfoData: {}
    };
  },
  created: function created() {
    this.pidPage();
    this.getTljPidUseInfo();
  },
  methods: {
    getTljPidUseInfo: function () {
      var _getTljPidUseInfo2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                type: 2
              };
              _context.n = 1;
              return (0, _marketingFunction.getTljPidUseInfo)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.getTljPidUseInfoData = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getTljPidUseInfo() {
        return _getTljPidUseInfo2.apply(this, arguments);
      }
      return getTljPidUseInfo;
    }(),
    // 列表
    pidPage: function () {
      var _pidPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _tljPromotionposition.pidPage)(params);
            case 1:
              res = _context2.v;
              this.tableData = res.data.data || [];
              this.total = res.data.total;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function pidPage() {
        return _pidPage2.apply(this, arguments);
      }
      return pidPage;
    }(),
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.pidPage();
    },
    onInitialize: function onInitialize() {
      this.onInit();
      this.pidPage();
    },
    onInit: function onInit() {
      this.queryData = {
        pid: '',
        status: null,
        type: 2,
        memberId: '',
        phone: '',
        page: 1,
        size: 10
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.pidPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.pidPage();
    },
    // 添加
    addPid: function () {
      var _addPid2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _tljPromotionposition.addPid)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.onClose();
                this.onInitialize();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function addPid() {
        return _addPid2.apply(this, arguments);
      }
      return addPid;
    }(),
    onRecharge: function onRecharge() {
      this.dialogVisible = true;
      this.operationType = 'add';
      this.titleTxt = '添加推广位';
    },
    // 编辑
    editPid: function () {
      var _editPid2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                id: this.ruleForm.id,
                newPid: this.ruleForm.pid
              };
              _context4.n = 1;
              return (0, _tljPromotionposition.editPid)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.onClose();
                this.onInitialize();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function editPid() {
        return _editPid2.apply(this, arguments);
      }
      return editPid;
    }(),
    // 删除
    handleDel: function handleDel(val) {
      var _this = this;
      this.$confirm("\u662F\u5426\u786E\u8BA4\u5220\u9664\u63A8\u5E7F\u4F4D?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deletePid(val.id);
      });
    },
    deletePid: function () {
      var _deletePid2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _tljPromotionposition.deletePid)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.onInitialize();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function deletePid(_x) {
        return _deletePid2.apply(this, arguments);
      }
      return deletePid;
    }(),
    handleEdit: function handleEdit(val) {
      this.dialogVisible = true;
      this.operationType = 'edit';
      this.titleTxt = '添加推广位';
      this.ruleForm.pid = val.pid;
      this.ruleForm.id = val.id;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm("\u662F\u5426".concat(_this2.operationType === 'add' ? '添加' : '编辑', "\u63A8\u5E7F\u4F4D?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this2.operationType === 'add') {
              _this2.addPid();
            } else {
              _this2.editPid();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm() {
      this.$refs['ruleForm'].resetFields();
    },
    onClose: function onClose() {
      this.ruleForm = {
        pid: '',
        type: 2
      };
      this.resetForm('ruleForm');
      this.dialogVisible = false;
      this.operationType = 'add';
    }
  }
};